/** Clé i18n du statut de complétion SCORM d'une ligne de suivi. */
export function completionLabelKey(status: string | null | undefined): string {
  switch (status) {
    case 'COMPLETED': return 'status.completed'
    case 'INCOMPLETE': return 'status.incomplete'
    case 'NOT_ATTEMPTED': return 'status.not_attempted'
    default: return 'status.unknown'
  }
}

/** Clé i18n du statut de réussite SCORM d'une ligne de suivi. */
export function successLabelKey(status: string | null | undefined): string {
  switch (status) {
    case 'PASSED': return 'status.passed'
    case 'FAILED': return 'status.failed'
    default: return 'status.unknown'
  }
}
